import React from "react";
import { motion } from "framer-motion";
import withStyles from "@mui/styles/withStyles";

export const styles = () => ({
  root: {
    position: "relative",
    width: "min-content",
  },
  bottomSection: {
    position: "absolute",
    bottom: "-6px",
  },
  container: {
    borderRadius: "50%",
    overflow: "hidden",
    boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.4)",
    transition: "box-shadow 0.3s ease-in-out",
  },
});

const TheHayley = ({ stroke = "#333", backgroundFill = "#F9CA54", frontFill = "#39728E", height = "59", width = "65", classes, isAnimated = true }) => {
  return (
    <div className={classes.root} data-testid="hayley-mascot-svg">
      <div data-testid="hayley-mascot-bg" className={`${classes.container} ${!isAnimated && "hayley-shadow-none"}`} style={{ background: backgroundFill }}>
        <div>
          <motion.svg
            animate={
              isAnimated
                ? {
                    y: [22, 1, 22],
                  }
                : { y: 22 }
            }
            transition={
              isAnimated
                ? {
                    duration: 2,
                    ease: "easeInOut",
                    times: [0, 0.2, 0.5, 0.8, 1],
                    repeat: Infinity,
                    repeatDelay: 5,
                  }
                : {}
            }
            width={width}
            height={height}
            viewBox="0 0 81 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask id="mask0_3350_681" maskUnits="userSpaceOnUse" x="0" y="0" width="81" height="81">
              <path
                d="M40.1426 80.3275C62.234 80.3275 80.1426 62.4189 80.1426 40.3275C80.1426 18.2361 62.234 0.327515 40.1426 0.327515C18.0512 0.327515 0.142578 18.2361 0.142578 40.3275C0.142578 62.4189 18.0512 80.3275 40.1426 80.3275Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_3350_681)">
              <path
                data-testid="hayley-mascot-svg-bot"
                d="M40.2677 77.3525C54.6218 77.3525 66.2581 65.7162 66.2581 51.3621C66.2581 37.008 54.6218 25.3717 40.2677 25.3717C25.9136 25.3717 14.2773 37.008 14.2773 51.3621C14.2773 65.7162 25.9136 77.3525 40.2677 77.3525Z"
                fill={frontFill}
              />
              <path
                d="M36.5016 63.3395C35.7427 62.9762 33.2641 61.8054 33.59 60.3196C33.8786 59.499 34.3036 60.1987 34.6447 60.2619C36.3254 61.1036 38.1788 61.463 40.119 61.3235C41.062 61.2575 42.0263 61.0175 42.9885 60.6094C43.3072 60.4697 43.6254 60.2515 43.9329 60.1474C44.266 60.0072 44.5993 59.9461 44.9181 59.967C45.058 59.9806 45.1822 60.0524 45.2765 60.1743C45.3709 60.2961 45.4317 60.4632 45.4521 60.6565C45.4724 60.8498 45.4515 61.0617 45.3916 61.2682C45.3318 61.4747 45.2355 61.6675 45.1135 61.8248C44.0138 63.1999 42.6425 63.4932 41.3626 63.6922C39.6548 64.0733 37.9999 63.9532 36.5016 63.3395Z"
                fill={backgroundFill}
              />
              <path
                d="M40.5668 23.2739C37.9289 23.2999 35.2935 23.1055 32.688 22.6928C29.4527 22.1166 29.0391 21.378 29.0391 20.8019C29.0391 20.2257 29.4527 19.4871 32.688 18.9109C35.2935 18.4982 37.9289 18.3038 40.5668 18.3299C43.2047 18.3035 45.8402 18.4979 48.4457 18.9109C51.6809 19.4871 52.0946 20.2257 52.0946 20.8019C52.0946 21.378 51.6809 22.1166 48.4457 22.6928C45.8402 23.1058 43.2047 23.3002 40.5668 23.2739ZM30.1224 20.7822C30.6148 21.2746 34.0618 22.225 40.5865 22.225C47.1112 22.225 50.5582 21.2992 51.0457 20.7822C50.5533 20.2602 47.1063 19.3394 40.5865 19.3394C34.0668 19.3394 30.6148 20.2897 30.1224 20.7822Z"
                fill={frontFill}
              />
              <path
                d="M54.2989 38.5096H26.4333C22.1619 38.5096 18.6992 41.8167 18.6992 45.8961C18.6992 49.9755 22.1619 53.2825 26.4333 53.2825H54.2989C58.5703 53.2825 62.033 49.9755 62.033 45.8961C62.033 41.8167 58.5703 38.5096 54.2989 38.5096Z"
                fill={backgroundFill}
              />
              <path
                d="M31.9927 50.2145C31.0079 48.9785 31.0817 47.1466 31.5791 45.7235C32.0764 44.3004 33.9034 43.6011 34.5337 45.428C35.1394 46.8807 34.4155 52.3959 31.9927 50.2145Z"
                fill={frontFill}
              />
              <path
                d="M45.8743 50.7835C43.5353 50.2419 44.3182 44.3229 46.2732 44.1259C47.8489 43.9683 48.1198 46.4649 48.0951 47.5729C48.1592 48.8384 47.5239 51.2464 45.8743 50.7835Z"
                fill={frontFill}
              />
              <path
                d="M49.0363 42.0628C49.4056 40.9056 46.7613 40.3689 45.9586 40.167C45.2692 40.0882 44.0973 39.6352 43.8215 40.5609C43.8056 40.6625 43.8108 40.7662 43.837 40.8655C43.8632 40.9649 43.9096 41.0578 43.9735 41.1383C44.0373 41.2188 44.1172 41.2852 44.208 41.3333C44.2988 41.3814 44.3986 41.4102 44.501 41.4178C44.9947 41.3841 45.4905 41.4089 45.9783 41.4916C46.6794 41.6216 47.3692 41.806 48.0416 42.0431C48.3518 42.1121 48.8098 42.4371 49.0363 42.0628Z"
                fill={frontFill}
              />
              <path
                d="M30.1875 41.9813C29.8182 40.8192 32.4625 40.2824 33.2652 40.0805C33.9546 40.0067 35.1266 39.5536 35.3974 40.4745C35.4141 40.5757 35.4095 40.6793 35.3839 40.7787C35.3584 40.878 35.3124 40.971 35.2489 41.0516C35.1855 41.1322 35.1059 41.1987 35.0153 41.2469C34.9247 41.295 34.8251 41.3238 34.7228 41.3313C34.2292 41.2975 33.7333 41.3223 33.2455 41.4052C32.5411 41.5346 31.8479 41.719 31.1724 41.9567C30.8621 42.0109 30.4042 42.3556 30.1875 41.9813Z"
                fill={frontFill}
              />
              <motion.path
                animate={
                  isAnimated
                    ? {
                        scaleX: [1, 0.5, 1, 0.5, 1],
                      }
                    : {}
                }
                transition={
                  isAnimated
                    ? {
                        duration: 2,
                        ease: "easeInOut",
                        times: [0, 0.2, 0.5, 0.8, 1],
                        repeat: Infinity,
                        repeatDelay: 5,
                      }
                    : {}
                }
                d="M11.6531 56.8233C9.60104 55.9073 9.73193 53.4354 10.5827 51.6281C11.1409 50.4274 11.9591 49.3816 12.9713 48.5751C8.84379 46.5216 10.2461 42.3705 14.1399 41.2527C13.0882 40.1841 12.0177 39.0072 11.6812 37.456C11.0267 35.4322 12.0832 32.9257 14.2755 32.8272C15.5095 32.7238 16.5238 33.6742 17.3232 34.5556C18.1891 35.6397 18.9008 36.8506 19.436 38.1504C19.5084 38.2687 19.5559 38.402 19.5752 38.5413C19.5946 38.6806 19.5854 38.8227 19.5482 38.9579C19.4781 39.1155 19.2724 39.2485 19.1228 39.1303C18.9199 38.8623 18.7356 38.5792 18.5712 38.2833C17.6878 36.8454 16.0377 34.0927 14.2381 34.0878C13.8874 34.0859 13.5437 34.1902 13.2478 34.3884C12.9519 34.5866 12.7164 34.8703 12.5693 35.2056C12.3634 35.8353 12.3783 36.5218 12.6114 37.1409C12.9716 38.203 13.5984 39.1424 14.425 39.8591C14.7105 40.1607 15.0134 40.4436 15.3319 40.7061C15.4909 40.836 15.5972 41.0247 15.6293 41.234C15.6614 41.4433 15.6169 41.6576 15.5048 41.8337C15.2563 42.1179 14.9293 42.3126 14.5699 42.3902C13.3686 42.7841 11.9616 43.1928 11.4007 44.5125C10.9613 45.5565 11.8681 46.5857 12.6815 47.0535C13.0702 47.2896 13.4748 47.4954 13.8922 47.669C14.0617 47.6933 14.2226 47.7628 14.3596 47.8709C14.4213 47.9504 14.4661 48.043 14.491 48.1423C14.5159 48.2416 14.5202 48.3454 14.5039 48.4466C14.4875 48.5479 14.4507 48.6443 14.396 48.7293C14.3412 48.8143 14.2699 48.886 14.1866 48.9395C13.8267 49.1758 13.4808 49.4319 13.1442 49.6929C11.9149 50.7368 10.8865 52.2437 10.807 53.9475C10.6902 55.2573 12.0177 56.0501 13.1442 55.9714C14.5045 55.8286 15.5983 54.8437 16.6968 54.0854C17.056 53.8558 17.4576 53.7097 17.8748 53.6569C17.7622 54.0581 17.58 54.4338 17.3372 54.7649C16.7823 55.3995 16.1256 55.9262 15.3973 56.321C14.2521 57.0104 12.8918 57.4536 11.6531 56.8233Z"
                fill={frontFill}
              />
              <motion.path
                animate={
                  isAnimated
                    ? {
                        scaleX: [1, 0.5, 1, 0.5, 1],
                      }
                    : {}
                }
                transition={
                  isAnimated
                    ? {
                        duration: 2,
                        ease: "easeInOut",
                        times: [0, 0.2, 0.5, 0.8, 1],
                        repeat: Infinity,
                        repeatDelay: 5,
                      }
                    : {}
                }
                d="M65.0936 57.1611C64.4065 57.0675 63.6119 56.9198 63.1818 56.2895C62.9013 55.8956 62.6676 55.1865 63.2893 55.0092C63.911 54.8319 64.3504 55.1569 64.8646 55.3194C66.1875 55.7478 67.5103 54.8516 68.0806 53.6058C68.9454 51.7345 67.4683 49.8584 66.2108 48.6322C66.0545 48.4533 65.9527 48.2291 65.9185 47.9886C65.8844 47.7481 65.9194 47.5023 66.0192 47.283C66.1809 47.0005 66.4253 46.781 66.7157 46.6576C67.0103 46.4717 67.2944 46.2679 67.5664 46.047C68.6275 45.333 69.3941 43.8705 68.7864 42.6C68.5265 42.0691 68.1479 41.6128 67.6833 41.2704C67.0382 40.8962 66.2108 40.4924 66.4773 39.5469C66.5933 39.2765 66.7375 39.0205 66.9073 38.7837C67.1223 38.3848 67.3093 37.9712 67.4916 37.5526C67.8822 36.7678 68.0935 35.8977 68.1086 35.0117C68.0526 33.9086 66.898 33.5344 66.0285 33.8889C64.6917 34.3813 63.7287 35.6715 62.9761 36.8435C62.4718 37.6599 62.0533 38.5317 61.7281 39.4435C61.7189 39.5022 61.6895 39.5553 61.6456 39.5925C61.6016 39.6298 61.546 39.6486 61.4897 39.6454C61.0222 39.4731 61.5645 38.3306 61.6813 38.0007C62.4947 36.0605 64.0185 33.6624 66.0098 32.9828C66.3279 32.846 66.6731 32.7939 67.0149 32.8312C67.3567 32.8684 67.6845 32.9939 67.9692 33.1965C68.254 33.399 68.4869 33.6725 68.6474 33.9925C68.8079 34.3126 68.8909 34.6694 68.8893 35.0314C68.936 36.6219 68.2395 38.109 67.5851 39.5026C68.1499 39.7855 68.6477 40.1975 69.0423 40.7086C69.4369 41.2197 69.7184 41.8171 69.8662 42.4572C70.4365 44.6189 69.0903 46.7512 67.4355 47.9281C68.4779 49.3118 69.3614 51.0254 69.3053 52.8524C69.1697 55.1618 67.3935 57.4024 65.0936 57.1611Z"
                fill={frontFill}
              />
            </g>
          </motion.svg>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(TheHayley);
